import { render, staticRenderFns } from "./RequPush9007.vue?vue&type=template&id=163c10d2&scoped=true&"
import script from "./RequPush9007.vue?vue&type=script&lang=js&"
export * from "./RequPush9007.vue?vue&type=script&lang=js&"
import style0 from "./RequPush9007.vue?vue&type=style&index=0&id=163c10d2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "163c10d2",
  null
  
)

export default component.exports